import React, { useEffect, useState } from "react";
import { auth } from "./firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate, Link, useLocation } from "react-router-dom";
import Toast from 'react-bootstrap/Toast';
import Alert from "react-bootstrap/Alert";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Turn} from "./types";

const axios = require("axios").default;

type UserInfo = {
  name: string,
  id: string,
  email: string,
}

function Dashboard() {
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState<UserInfo>();
  const [alert, setAlert] = useState({alertType: "", msg: ""});
  const [showAlert, toggleShowAlert] = useState(false);
  const [turns, setTurns] = useState<Turn[]>([])
  const [loadingTurns, setLoadingTurns] = useState(true);
  const location = useLocation();
  const fetchTurns = (id: string) => {
    setLoadingTurns(true);
    axios.get(`https://europe-west1-gran-recogida.cloudfunctions.net/api/users/${id}/turns`)
    .then((data: any) => {
      setTurns(data.data);
      setLoadingTurns(false);
    })
    .catch((error: any) => {
      console.log(error);
    })
  };
  useEffect(() => {
    if (loading) {
      navigate("/")
    }
    if (!user) {
      navigate("/")
    }
  }, [user, loading]);
  useEffect(() => {
    if(!loading && user) {
      axios.get(`https://europe-west1-gran-recogida.cloudfunctions.net/api/users/${user.uid}`)
        .then((response: any) => {
          if(response.status != 200) {
            throw Error(response.statusText);
          }
          return response;
        })
        .then((data: any) => {
            setUserInfo(data.data);
            fetchTurns(data.data.id);
        })
        .catch((error: any) => {
          navigate("/users/new");
        })
    }
  },[user, loading]);
  const deleteTurn = (id: string) => {
    axios.delete(`https://europe-west1-gran-recogida.cloudfunctions.net/api/users/${userInfo?.id}/turns/${id}`)
    .then(() => {
      setAlert({alertType: "success", msg: "Anulado"});
      toggleShowAlert(true);
      if (userInfo?.id) fetchTurns(userInfo.id);
    })
    .catch((err: any) => {
      console.log(err);
    })
  };
  const turnsList = turns.map((turn) =>
    <li key={turn.id} className="list-group-item">
      {turn.name} <a onClick={() => deleteTurn(turn.id)} href="#">Anular</a>
    </li>
  );
  return (
    <div className="m-5">
         {userInfo && 
          <div>
            <Row className="justify-content-md-center">
              <Col>
                <Toast show={showAlert} onClose={() => toggleShowAlert(false)}>
                <Toast.Header>
                    <strong className="mr-auto">Alert</strong>
                  </Toast.Header>
                  <Toast.Body>
                    {alert.alertType === "error" &&
                      <Alert variant="danger">
                        {alert.msg}
                      </Alert>
                    }
                    {alert.alertType === "success" &&
                      <Alert variant="success">
                        {alert.msg}
                      </Alert>
                    }
                  </Toast.Body>
                </Toast>
              </Col>
            </Row>
            <Row>
            <Col className="order-md-last col-12 col-sm-2">
                <Link 
                  to="/new" state={{userId: userInfo?.id}} 
                  className="btn btn-primary"
                >
                  Elige turno
                </Link>
              </Col>
              <Col className="col-12 col-sm-10">
                {turns.length > 0 && 
                  <div>
                    <h2>Tus turnos</h2>
                      <ul className="list-group list-group-flush">
                        {turnsList}
                      </ul>
                  </div>
                }
                {!loadingTurns && turns.length == 0 &&
                  <div>
                    <p>No tienes turnos ahora mismo. ¡Hazte voluntario/a!</p>
                  </div>
                }
                {loadingTurns &&
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                  </div>
                }
              </Col>
            </Row>
          </div>
          }
    </div>
  );
}
export default Dashboard;
